import React from "react";
import {
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { format } from "date-fns";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFF",
    padding: "10px",
    border: "1px solid #000",
  },
  barcodeSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0px 0",
  },
  header: { fontSize: 14, marginBottom: 5, textAlign: "center" },
  infoText: { fontSize: 8, margin: "1px 0" },
  infoTextCenter: { fontSize: 8, margin: "1px 0", textAlign: "center" },
  image: { width: 60, height: 60 },
  imageLogo: { width: 120, height: 60 },
  imageBarcode: { width: "100%", height: 100, textAlign: "center" },
  imageBarcodeLpn: { width: "100%", height: 50, textAlign: "center" },
});

const DocumentoPDFShippingLabelPrintBicci = ({
  order,
  orderDetailsCliente = {}, // ✅ CLAVE: evita undefined
  barcodeImage,
  qrImage,
  barcodeImageLpn,
}) => {
  // ✅ Fallbacks: si no viene orderDetailsCliente, toma desde order
  const lpnRaw =
    orderDetailsCliente?.lpn ??
    order?.lpn ??
    order?.int_lpn ??
    order?.soc ??
    "";

  const socRaw = orderDetailsCliente?.soc ?? order?.soc ?? "";

  const safeLpn = lpnRaw && lpnRaw !== "isRequire" ? String(lpnRaw) : "N/A";
  const safeSoc = socRaw && socRaw !== "isRequire" ? String(socRaw) : "N/A";

  const createdAtMs = order?.createdAt?.seconds
    ? order.createdAt.seconds * 1000
    : null;

  const logo =
    "https://firebasestorage.googleapis.com/v0/b/bicci-7ed2f.appspot.com/o/webfrontend%2Fweb-bicciexpress%2FLogoBicci01x04.png?alt=media&token=0d36671d-c7df-43e8-97c2-1be128037b00";

  return (
    <Document>
      <Page size={[4 * 72, 6 * 72]} style={styles.page}>
        <View>
          <Text style={styles.header}>BICCI EXPRESS</Text>

          <View style={styles.barcodeSection}>
            {qrImage ? <Image src={qrImage} style={styles.image} /> : null}
            <Image src={logo} style={styles.imageLogo} />
          </View>

          <Text style={styles.infoText}>Origen: Falabella</Text>

          <View>
            {barcodeImage ? (
              <Image src={barcodeImage} style={styles.imageBarcode} />
            ) : null}
          </View>

          <Text style={styles.infoTextCenter}>ID: {order?.id ?? "N/A"}</Text>

          <Text style={styles.infoText}>COD LPN: {safeLpn}</Text>
          <Text style={styles.infoText}>{safeSoc}</Text>

          <Text style={styles.infoText}>
            Cliente: {order?.userName ?? "N/A"}
          </Text>
          <Text style={styles.infoText}>
            Teléfono: {order?.userPhone ?? "N/A"}
          </Text>

          <Text style={styles.infoText}>Dirección:</Text>
          <Text style={styles.infoText}>{order?.toAddress ?? "N/A"}</Text>

          {order?.commune2 ? (
            <Text style={styles.infoText}>Dirección 1: {order.commune2}</Text>
          ) : null}
          {order?.commune ? (
            <Text style={styles.infoText}>Dirección 2: {order.commune}</Text>
          ) : null}

          <Text style={styles.infoText}>
            TIPO: {order?.deliveryType ?? "N/A"}
          </Text>

          <Text style={styles.infoText}>
            Fecha de viaje{" "}
            {createdAtMs ? format(createdAtMs, "dd/MM/yy HH:mm:ss") : "N/A"}
          </Text>

          <View>
            {barcodeImageLpn ? (
              <Image src={barcodeImageLpn} style={styles.imageBarcodeLpn} />
            ) : null}
          </View>

          <Text style={styles.infoTextCenter}>LPN</Text>
        </View>
      </Page>
    </Document>
  );
};

export default DocumentoPDFShippingLabelPrintBicci;
